export const parseIntProductionReducerHelper = (dataToInt: string | number | undefined) => dataToInt
			? parseInt(dataToInt as string, 10)
			: 0;

export default {};
